/**
 * Wolfhunter Dark Theme — Main JavaScript
 */

(function() {
  'use strict';

  /* ============================================================
     MOBILE MENU
     ============================================================ */
  function toggleMobileMenu() {
    var menu = document.getElementById('mobile-menu');
    var toggle = document.getElementById('mobile-toggle');
    var menuIcon = document.getElementById('menu-icon');
    var closeIcon = document.getElementById('close-icon');
    if (!menu) return;
    var isOpen = menu.classList.contains('is-open');
    if (isOpen) {
      menu.classList.remove('is-open');
      menu.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      menuIcon.style.display = '';
      closeIcon.style.display = 'none';
    } else {
      menu.classList.add('is-open');
      menu.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      menuIcon.style.display = 'none';
      closeIcon.style.display = '';
    }
  }
  window.toggleMobileMenu = toggleMobileMenu;

  /* ============================================================
     SEARCH MODAL
     ============================================================ */
  function openSearch() {
    var modal = document.getElementById('search-modal');
    if (!modal) return;
    modal.style.display = 'flex';
    setTimeout(function() {
      var input = document.getElementById('search-input');
      if (input) input.focus();
    }, 100);
    document.body.style.overflow = 'hidden';
  }

  function closeSearch() {
    var modal = document.getElementById('search-modal');
    if (!modal) return;
    modal.style.display = 'none';
    document.body.style.overflow = '';
  }

  window.openSearch = openSearch;
  window.closeSearch = closeSearch;

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeSearch();
      closeCart();
    }
  });

  /* ============================================================
     CART DRAWER
     ============================================================ */
  function openCart() {
    var drawer = document.getElementById('cart-drawer');
    var overlay = document.getElementById('cart-overlay');
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.style.display = 'block';
    document.body.style.overflow = 'hidden';
    fetchCart();
  }

  function closeCart() {
    var drawer = document.getElementById('cart-drawer');
    var overlay = document.getElementById('cart-overlay');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.style.display = 'none';
    document.body.style.overflow = '';
  }

  window.openCart = openCart;
  window.closeCart = closeCart;

  function fetchCart() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        renderCartDrawer(cart);
        updateCartCount(cart.item_count);
      })
      .catch(function(err) { console.error('Cart fetch error:', err); });
  }

  function renderCartDrawer(cart) {
    var emptyEl = document.getElementById('cart-empty');
    var itemsEl = document.getElementById('cart-items');
    var footerEl = document.getElementById('cart-footer');
    var subtotalEl = document.getElementById('cart-subtotal');
    if (!emptyEl || !itemsEl || !footerEl) return;
    if (cart.item_count === 0) {
      emptyEl.style.display = 'block';
      itemsEl.style.display = 'none';
      footerEl.style.display = 'none';
    } else {
      emptyEl.style.display = 'none';
      itemsEl.style.display = 'block';
      footerEl.style.display = 'flex';
      var html = '';
      cart.items.forEach(function(item) {
        var price = (item.final_line_price / 100).toLocaleString('de-DE', { style: 'currency', currency: cart.currency });
        html += '<div class="cart-drawer-item">';
        if (item.image) html += '<img src="' + item.image + '" alt="' + escapeHtml(item.title) + '" class="cart-drawer-item__image" loading="lazy">';
        html += '<div class="cart-drawer-item__details">';
        html += '<a href="' + item.url + '" class="cart-drawer-item__title" onclick="closeCart()">' + escapeHtml(item.product_title) + '</a>';
        if (item.variant_title && item.variant_title !== 'Default Title') html += '<p class="cart-drawer-item__variant">' + escapeHtml(item.variant_title) + '</p>';
        html += '<p class="cart-drawer-item__price">' + price + '</p>';
        html += '</div>';
        html += '<button class="cart-drawer-item__remove" onclick="removeCartItem(\'' + item.key + '\')" aria-label="Remove">✕</button>';
        html += '</div>';
      });
      itemsEl.innerHTML = html;
      if (subtotalEl) {
        subtotalEl.textContent = (cart.total_price / 100).toLocaleString('de-DE', { style: 'currency', currency: cart.currency });
      }
    }
  }

  function removeCartItem(key) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      renderCartDrawer(cart);
      updateCartCount(cart.item_count);
    });
  }
  window.removeCartItem = removeCartItem;

  function updateCartCount(count) {
    var countEl = document.getElementById('cart-count');
    if (!countEl) return;
    if (count > 0) {
      countEl.textContent = count > 99 ? '99+' : count;
      countEl.style.display = 'flex';
    } else {
      countEl.style.display = 'none';
    }
  }
  window.updateCartCount = function() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) { updateCartCount(cart.item_count); });
  };

  function escapeHtml(str) {
    if (!str) return '';
    return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* ============================================================
     STICKY HEADER
     ============================================================ */
  var header = document.getElementById('wh-header');
  if (header) {
    window.addEventListener('scroll', function() {
      if (window.scrollY > 20) {
        header.style.background = 'rgba(10,10,10,0.98)';
      } else {
        header.style.background = 'rgba(10,10,10,0.95)';
      }
    }, { passive: true });
  }

  /* ============================================================
     INIT
     ============================================================ */
  document.addEventListener('DOMContentLoaded', function() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) { updateCartCount(cart.item_count); })
      .catch(function() {});
  });

})();

/* ============================================================
   PRODUCT VARIANT SWITCHER
   ============================================================ */

function syncThumbs(selectedColor, activeImageId) {
  var thumbs = document.querySelectorAll('.wh-product-page__thumb');

  var taggedColors = [];
  thumbs.forEach(function(t) {
    var c = t.getAttribute('data-color');
    if (c && c !== '' && taggedColors.indexOf(c) === -1) taggedColors.push(c);
  });

  var hasColorMatch = taggedColors.indexOf(selectedColor) !== -1;

  thumbs.forEach(function(thumb) {
    var thumbId    = String(thumb.getAttribute('data-image-id'));
    var thumbColor = thumb.getAttribute('data-color');

    if (hasColorMatch) {
      thumb.style.display = (thumbColor === selectedColor || thumbColor === '') ? '' : 'none';
    } else {
      thumb.style.display = (taggedColors.indexOf(thumbColor) === -1) ? '' : 'none';
    }

    thumb.classList.remove('wh-product-page__thumb--active');
    if (activeImageId && thumbId === String(activeImageId)) {
      thumb.classList.add('wh-product-page__thumb--active');
    }
  });

  var anyVisible = false;
  thumbs.forEach(function(t) { if (t.style.display !== 'none') anyVisible = true; });
  if (!anyVisible) {
    thumbs.forEach(function(t) { t.style.display = ''; });
  }

  var anyActive = false;
  thumbs.forEach(function(t) {
    if (t.classList.contains('wh-product-page__thumb--active')) anyActive = true;
  });
  if (!anyActive) {
    thumbs.forEach(function(t) {
      if (!anyActive && t.style.display !== 'none') {
        t.classList.add('wh-product-page__thumb--active');
        anyActive = true;
      }
    });
  }
}

function whSelectThumb(btn) {
  document.querySelectorAll('.wh-product-page__thumb').forEach(function(b) {
    b.classList.remove('wh-product-page__thumb--active');
  });
  btn.classList.add('wh-product-page__thumb--active');
  var img = document.getElementById('product-main-image');
  if (img) img.src = btn.getAttribute('data-image-src');
}

function whSelectOption(btn) {
  var section = document.getElementById('wh-product-page');
  if (!section) return;

  if (!window.wh_productData) {
    try {
      window.wh_productData = JSON.parse(section.getAttribute('data-product'));
      window.wh_selectedOptions = section.getAttribute('data-selected-options').split('|');
    } catch(e) { console.error('Product data error:', e); return; }
  }

  var index = parseInt(btn.getAttribute('data-option-index'));
  var value  = btn.getAttribute('data-option-value');
  window.wh_selectedOptions[index] = value;

  document.querySelectorAll('[data-option-index="' + index + '"]').forEach(function(b) {
    b.classList.remove('wh-option-btn--active');
  });
  btn.classList.add('wh-option-btn--active');

  var label = document.getElementById('option-value-' + index);
  if (label) label.textContent = value;

  var matchedVariant = null;
  for (var i = 0; i < window.wh_productData.variants.length; i++) {
    var v    = window.wh_productData.variants[i];
    var opts = [v.option1, v.option2, v.option3];
    var match = true;
    for (var j = 0; j < window.wh_selectedOptions.length; j++) {
      if (opts[j] !== window.wh_selectedOptions[j]) { match = false; break; }
    }
    if (match) { matchedVariant = v; break; }
  }

  if (!matchedVariant) return;

  var variantInput = document.getElementById('variant-id');
  if (variantInput) variantInput.value = matchedVariant.id;

  var priceEl = document.getElementById('product-price');
  if (priceEl) priceEl.innerHTML = '<span class="wh-product-page__current">€' +
    (matchedVariant.price / 100).toFixed(2).replace('.', ',') + '</span>';

  var cartBtn = document.getElementById('add-to-cart-btn');
  if (cartBtn) {
    cartBtn.disabled    = !matchedVariant.available;
    cartBtn.textContent = matchedVariant.available ? 'Add To Cart' : 'Sold Out';
  }

  var mainImg = document.getElementById('product-main-image');

  if (matchedVariant.featured_image && matchedVariant.featured_image.src) {
    if (mainImg) mainImg.src = matchedVariant.featured_image.src;
    syncThumbs(window.wh_selectedOptions[0], matchedVariant.featured_image.id);
  } else {
    syncThumbs(window.wh_selectedOptions[0], null);
    if (mainImg) {
      var done = false;
      document.querySelectorAll('.wh-product-page__thumb').forEach(function(t) {
        if (!done && t.style.display !== 'none') {
          mainImg.src = t.getAttribute('data-image-src');
          done = true;
        }
      });
    }
  }

  window.history.replaceState({}, '', '?variant=' + matchedVariant.id);
}

window.whSelectThumb  = whSelectThumb;
window.whSelectOption = whSelectOption;

/* ============================================================
   SYNC THUMBNAILS ON PAGE LOAD
   ============================================================ */
document.addEventListener('DOMContentLoaded', function() {
  var section = document.getElementById('wh-product-page');
  if (!section) return;

  try {
    window.wh_productData     = JSON.parse(section.getAttribute('data-product'));
    window.wh_selectedOptions = section.getAttribute('data-selected-options').split('|');
  } catch(e) { return; }

  var urlParams      = new URLSearchParams(window.location.search);
  var variantId      = urlParams.get('variant');
  var currentVariant = null;

  // 1. URL variant param
  if (variantId) {
    for (var i = 0; i < window.wh_productData.variants.length; i++) {
      if (String(window.wh_productData.variants[i].id) === String(variantId)) {
        currentVariant = window.wh_productData.variants[i];
        break;
      }
    }
  }

  // 2. Match by product featured image → sync color button + thumbnails
  if (!currentVariant) {
    var featuredImageId = section.getAttribute('data-featured-image-id');
    if (featuredImageId) {
      for (var i = 0; i < window.wh_productData.variants.length; i++) {
        var v = window.wh_productData.variants[i];
        if (v.featured_image && String(v.featured_image.id) === String(featuredImageId)) {
          currentVariant = v;
          window.wh_selectedOptions[0] = v.option1;
          document.querySelectorAll('[data-option-index="0"]').forEach(function(b) {
            b.classList.remove('wh-option-btn--active');
            if (b.getAttribute('data-option-value') === v.option1) b.classList.add('wh-option-btn--active');
          });
          var lbl = document.getElementById('option-value-0');
          if (lbl) lbl.textContent = v.option1;
          break;
        }
      }
    }
  }

  // 3. Fallback — selected options from Liquid
  if (!currentVariant) {
    for (var i = 0; i < window.wh_productData.variants.length; i++) {
      var v    = window.wh_productData.variants[i];
      var opts = [v.option1, v.option2, v.option3];
      var match = true;
      for (var j = 0; j < window.wh_selectedOptions.length; j++) {
        if (opts[j] !== window.wh_selectedOptions[j]) { match = false; break; }
      }
      if (match) { currentVariant = v; break; }
    }
  }

  if (!currentVariant) return;

  var mainImg = document.getElementById('product-main-image');
  if (currentVariant.featured_image) {
    if (mainImg) mainImg.src = currentVariant.featured_image.src;
    syncThumbs(window.wh_selectedOptions[0], currentVariant.featured_image.id);
  } else {
    syncThumbs(window.wh_selectedOptions[0], null);
  }
});